module.exports = __webpack_public_path__ + "img/2.b034e335.png";